<template>
  <span class="rolling-number" :class="numberClass">
    <span v-if="prefix" class="rolling-prefix">{{ prefix }}</span>
    <span class="rolling-body">
      <span
        v-for="item in displayItems"
        :key="item.key"
        :class="item.type === 'sep' ? 'rolling-sep' : 'rolling-digit'"
      >
        <template v-if="item.type === 'sep'">{{ item.value }}</template>
        <span v-else class="rolling-digit-viewport">
          <span
            class="rolling-digit-strip"
            :class="{ animating: isAnimating }"
            :style="{ transform: `translate3d(0, -${item.digit * 10}%, 0)` }"
          >
            <span
              v-for="n in 10"
              :key="n"
              class="rolling-digit-cell"
            >{{ n - 1 }}</span>
          </span>
        </span>
      </span>
    </span>
  </span>
</template>

<script>
export default {
  name: "RollingNumber",
  props: {
    value: {
      type: Number,
      default: 0,
    },
    prefix: {
      type: String,
      default: "",
    },
    numberClass: {
      type: [String, Array, Object],
      default: "",
    },
    duration: {
      type: Number,
      default: 550,
    },
    replayKey: {
      type: [String, Number, Boolean],
      default: undefined,
    },
  },
  data() {
    return {
      displayItems: [],
      isAnimating: false,
    };
  },
  watch: {
    value(newVal, oldVal) {
      if (oldVal === undefined) {
        return;
      }
      this.animateTo(newVal, true);
    },
    replayKey() {
      if (this.replayKey === undefined) {
        return;
      }
      this.animateTo(this.value, true);
    },
  },
  mounted() {
    this.animateTo(this.value, true);
  },
  methods: {
    buildDisplayItems(num) {
      const formatted = Number(num || 0).toLocaleString("zh-CN");
      return formatted.split("").map((char, index) => {
        if (!/\d/.test(char)) {
          return {
            type: "sep",
            value: char,
            key: `sep-${index}-${char}`,
          };
        }
        return {
          type: "digit",
          digit: Number(char),
          key: `digit-${index}`,
        };
      });
    },
    animateTo(target, fromZero = false) {
      this.isAnimating = false;
      if (fromZero) {
        this.displayItems = this.buildDisplayItems(0);
      }
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.isAnimating = true;
            this.displayItems = this.buildDisplayItems(target);
          });
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.rolling-number {
  display: inline-flex;
  align-items: center;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.rolling-prefix {
  flex-shrink: 0;
  line-height: 1;
}

.rolling-body {
  display: inline-flex;
  align-items: center;
  line-height: 1;
	font-size: 28px;
	// letter-spacing: -1px;
}

.rolling-sep {
  flex-shrink: 0;
	display: none;
}

.rolling-digit {
  display: inline-block;
  flex-shrink: 0;
	// margin: 0 2px;
}

.rolling-digit-viewport {
  display: block;
  height: 1em;
  overflow: hidden;
  line-height: 1;
}

.rolling-digit-strip {
  display: flex;
  flex-direction: column;
  will-change: transform;

  &.animating {
    transition: transform 0.55s cubic-bezier(0.22, 1, 0.36, 1);
  }
}

.rolling-digit-cell {
  height: 1em;
  line-height: 1em;
  text-align: center;
}
</style>
